import { EditEquityMarketSharePurchaseContractTemplateModalContextType } from '../types/EditEquityMarketSharePurchaseContractTemplateModalContextType';

export const editEquityMarketSharePurchaseContractTemplateModalInitValue: EditEquityMarketSharePurchaseContractTemplateModalContextType =
  {
    data: {
      societyId: '',
      documentId: null,
      contractText: '',
      isLoading: false,
      isSaving: false,
      loadError: false,
      editorInstance: null,
    },
    actions: {
      handleCloseModal: () => {},
      setContractText: () => {},
      insertVariable: () => {},
      setEditorInstance: () => {},
      onEditorChange: () => {},
      handleSave: async () => {},
    },
  };
